import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from "react-router";
import ReturnList from './ReturnList';

@inject('commonStore','orderReturnStore')
@observer
class OrderReturnContainer extends Component {

  UNSAFE_componentWillMount() {
    this.props.orderReturnStore.setCommonStoreInfo(this.props.commonStore);
    this.props.orderReturnStore.onClear();
    this.props.orderReturnStore.disReturnList(1);
  }

  render() {
    const { sessionLoginInfo } = this.props.commonStore;
    return (
      <ReturnList
        ceType={sessionLoginInfo?.ceType || "" }
        cGbn={sessionLoginInfo?.cGbn || "" }
      />
    );
  }
}

export default withRouter(OrderReturnContainer);
